/**
 * SplashScreen
 *
 * 起動時 1.5秒のスカウター起動演出。
 * 要件の4ステップを CSS animation の delay で繋ぐ：
 *   1. 0.0-0.3s : LEDドットフェードイン
 *   2. 0.3-0.8s : "SCOUTER LENS" タイプライター
 *   3. 0.8-1.2s : レンズ枠ストローク描画（SVG）
 *   4. 1.2-1.5s : BOOTING... → READY → 全体フェードアウト
 *
 * 親（App or main.tsx）でマウントから一定時間後に unmount してもらう想定。
 */

import { useEffect, useState } from 'react';

import styles from './SplashScreen.module.css';

const TOTAL_DURATION_MS = 1500;
const READY_AT_MS = 1300;

export interface SplashScreenProps {
  /** アニメ完了時に呼ばれる（親でアンマウント判断する） */
  onComplete: () => void;
}

export function SplashScreen({ onComplete }: SplashScreenProps) {
  const [phaseReady, setPhaseReady] = useState(false);

  // BOOTING... → READY に切り替えるタイミング
  useEffect(() => {
    const readyTimer = window.setTimeout(() => setPhaseReady(true), READY_AT_MS);
    const completeTimer = window.setTimeout(onComplete, TOTAL_DURATION_MS);
    return () => {
      window.clearTimeout(readyTimer);
      window.clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div className={styles.root} aria-hidden>
      <span className={styles.led} />

      <div className={styles.typewriter}>
        <span className={styles.typewriterText}>SCOUTER LENS</span>
      </div>

      <svg
        className={styles.lensFrame}
        viewBox="0 0 140 175"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* 4隅から中央に向けて描かれるよう、stroke-dashoffset で全長を引っ込めて
            アニメで 0 まで戻す */}
        <rect
          x="2"
          y="2"
          width="136"
          height="171"
          rx="14"
          ry="14"
          className={styles.lensPath}
        />
      </svg>

      <div className={`${styles.status} ${phaseReady ? styles.statusReady : ''}`}>
        {phaseReady ? 'READY' : 'BOOTING...'}
      </div>
    </div>
  );
}
